import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTitle',
  standalone: false,
})
export class FormatTitlePipe implements PipeTransform {
  transform(value: string) {
    if (!value) return '';

    switch (value) {
      case 'BarRestaurant':
        return 'Bar/Restaurant';

      case 'CStore':
        return 'CStore';

      case 'LLC':
        return 'LLC';
      
      case 'LLP':
        return 'LLP';

      default:
        return value
          .replace(/^[a-z]/g, (char: string) => ` ${char.toUpperCase()}`)
          .replace(/[A-Z]|[0-9]+/g, ' $&')
          .replace(/(?:\s+)/, (char: any) => '');
    }
  }
}
